const NON_TRACKABLE_PATH_PREFIXES = [
  "/admin",
  "/api",
  "/_next",
  "/sitemaps/",
] as const;
const NON_TRACKABLE_EXACT_PATHS = new Set([
  "/favicon.ico",
  "/indexnow-key.txt",
  "/manifest.webmanifest",
  "/robots.txt",
  "/sitemap.xml",
  "/sitemap_index.xml",
  "/sw.js",
]);

export function normalizeVisitorPath(rawPath: string): string | null {
  const trimmed = rawPath.trim();
  if (!trimmed) {
    return null;
  }

  let parsed: URL;
  try {
    parsed =
      trimmed.startsWith("http://") || trimmed.startsWith("https://")
        ? new URL(trimmed)
        : new URL(trimmed, "http://localhost");
  } catch {
    return null;
  }

  const pathname = parsed.pathname.replace(/\/{2,}/g, "/") || "/";
  return `${pathname}${parsed.search}`;
}

export function isTrackableVisitorPath(path: string): boolean {
  if (!path.startsWith("/")) {
    return false;
  }

  const pathname = path.split("?", 1)[0] ?? path;
  if (NON_TRACKABLE_EXACT_PATHS.has(pathname)) {
    return false;
  }

  if (pathname.startsWith("/icons/")) {
    return false;
  }

  return !NON_TRACKABLE_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
